// extracted by mini-css-extract-plugin
module.exports = {"container":"loader_container__1KonJ","three-dots-loader":"loader_three-dots-loader__PcLSo","grow":"loader_grow__2o1OK","dark-loader":"loader_dark-loader__I-9vW"};